app.service("ColourRouteService", ['$rootScope', function ($rootScope) {

    const modelConstructor = $rootScope.model_constructor;

    const RouteChoice = modelConstructor.RouteChoice;

    const ColourRouteModel = modelConstructor.extend(modelConstructor.RouteModel, {
        id: "colour_route",
        navigation_pointer: "colour_id",
        next_model_id: "style_route",
        name: "Colour Route"
    });

    this.factory = new modelConstructor.RouteFactory({

        birth: function (values) {
            return new ColourRouteModel(values);
        },

        applyModelVariation: applyModelVariation
    });

    function applyModelVariation(model) {

        this.super(model);

        const variationIDs = model.variation_ids;
        const colourModel = $rootScope.factory.colour.getModel(variationIDs);
        const choiceOrder = colourModel.choice_order.slice();
        const fromChoices = colourModel.choices;
        const choices = {};
        for (let choiceID in fromChoices) {
            const fromChoice = fromChoices[choiceID];
            choices[choiceID] = new RouteChoice({
                id: choiceID,
                name: fromChoice.name,
                state_values: {
                    colour_name: fromChoice.name,
                    colour_detailed_name: fromChoice.colour_detailed_name,
                    colour_surcharge: fromChoice.surcharge ? parseFloat(fromChoice.surcharge) : 0,
                    colour_grain: fromChoice.grain, //vertical/horizontal
                    colour_img_src: fromChoice.getImgSrc()
                }
            })
        }

        model.choice_order = choiceOrder;
        model.choices = choices;
    }

}]);